// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"iframes_videoContainer__3R1yC","videoIframe":"iframes_videoIframe__sCv0Y"};